import { FC } from 'react';
import { Label } from 'semantic-ui-react';

import { useSocialWallUnreadCount } from './hooks/useSocialWallUnreadCount';

export const SocialWallLabelV2: FC = (props: any) => {
  const { data, isLoading, error } = useSocialWallUnreadCount();
  const unreadCount = data?.unreadCount;

  if (isLoading || error || !unreadCount) return null;

  return (
    <Label className="social-wall-count" {...props}>
      {unreadCount}
    </Label>
  );
};
